// extracted by mini-css-extract-plugin
module.exports = {"main":"_3BFd6Y3juS1YATZzXWsJvI","language":"_1MoaOFUje92kbLKlYjCtxA","placeholder":"xOMm2u72w4YGwvKSFTrDN","googleTranslateControl":"RII4P6Ulq_BiKH0ylxMIG"};